import main from './analytics-shell';
export default main;